// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Error[data-v-2d9dfdee]{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;height:500px;padding:16px}.message[data-v-2d9dfdee]{margin-bottom:24px}.link[data-v-2d9dfdee]{color:#ef6530;font-weight:700;transition:.3s}.link[data-v-2d9dfdee]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
